import React, { useState, useEffect } from 'react'
import { Offcanvas, Spinner } from 'react-bootstrap'
import { RiCloseLine } from 'react-icons/ri'
import { CheckOutIcon } from '../../../icons/icons'
import { useDispatch, useSelector } from 'react-redux'
import { setCheckInData, setCheckInStatus } from '../../../redux/appDataSlice'
import { decryptData } from '../../../../utils/api/encrypted'
import ApiFunction from '../../../../utils/api/apiFuntions'
import PLACE_PLACEHOLDER from '../../../../utils/placePlaceholder'

const CheckOut = ({ show, hide, successDrawer }) => {
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [placeImageUrl, setPlaceImageUrl] = useState(PLACE_PLACEHOLDER);
    const [imageLoading, setImageLoading] = useState(false);
    const [imageError, setImageError] = useState(false);

    const dispatch = useDispatch();
    const RemainingTime = useSelector(state => state.appData?.checkInTime);
    const checkInData = useSelector(state => state?.appData?.checkInData);
    const place_id = checkInData?.place_id;
    const placeName = checkInData?.place_name || checkInData?.location?.name || '';
    const { post } = ApiFunction();
    const encryptedToken = useSelector(state => state?.appData?.userToken);
    const userToken = decryptData(encryptedToken);

    const clearCheckInStorage = () => {
        localStorage.removeItem('checkInLat');
        localStorage.removeItem('checkInLong');
        localStorage.removeItem('checkInData');
        localStorage.removeItem('checkInType');
        localStorage.removeItem('checkInPlaceName');
        localStorage.removeItem('checkin_data_persistent');
        localStorage.removeItem('checkin_status_persistent');
    };

    useEffect(() => {
        const fetchPlaceImage = async () => {
            setPlaceImageUrl(PLACE_PLACEHOLDER);
            setImageError(false);

            if (!place_id || place_id === 'current' || !window.google?.maps?.places) {
                return;
            }

            setImageLoading(true);

            try {
                const mapDiv = document.createElement('div');
                const map = new window.google.maps.Map(mapDiv);
                const service = new window.google.maps.places.PlacesService(map);

                service.getDetails({ placeId: place_id, fields: ['photos', 'name'] }, (place, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK && place?.photos?.length > 0) {
                        setPlaceImageUrl(place.photos[0].getUrl({ maxWidth: 200, maxHeight: 200 }));
                    }
                    setImageLoading(false);
                });
            } catch (err) {
                console.error('Error fetching place image:', err);
                setImageLoading(false);
            }
        };

        if (place_id && place_id !== 'current') {
            fetchPlaceImage();
        }
    }, [place_id]);

    const handleImageError = () => {
        if (!imageError) {
            setImageError(true);
            setPlaceImageUrl(PLACE_PLACEHOLDER);
        }
    };

    const handleCheckOut = async () => {
        setLoading(true);
        setError('');
        const checkInId = checkInData?.checkInId;
        if (!checkInId) {
            setError('Missing check-in id. Please refresh and try again.');
            setLoading(false);
            return;
        }

        const currentTime = new Date().toISOString();
        const apiData = new FormData();
        apiData.append('type', 'update_data');
        apiData.append('user_id', userToken);
        apiData.append('id', checkInId);
        apiData.append('table_name', 'check_in');
        apiData.append('checkout_time', currentTime);
        apiData.append('checkout_type', 'user');

        try {
            const res = await post('', apiData);
            if (res?.result) {
                const nameForComplete = placeName;
                dispatch(setCheckInStatus(false));
                dispatch(setCheckInData({}));
                clearCheckInStorage();
                hide();
                if (successDrawer) successDrawer(nameForComplete);
            } else {
                setError(res?.message || 'Checkout failed. Please try again.');
            }
        } catch (err) {
            console.log('checkout error =>', err);
            setError(typeof err === 'string' ? err : (err?.message || 'Checkout failed. Please try again.'));
        } finally {
            setLoading(false);
            // Keep drawer open on failure — only hide on success above
        }
    }

    return (
        <>
            <Offcanvas backdropClassName="blurred-backdrop-offcanvas" show={show} placement='bottom' onHide={hide} className="offcanvas-bottom offcanvasBG">
                <Offcanvas.Header className='relative py-4'>
                    <h1 className='britti fs_18 mb-0 text-center w-full'>Check-out</h1>
                    <RiCloseLine onClick={hide} className='w-[24px] h-[24px] absolute right-5' />
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className=' flex flex-col items-center pt-[20px] h-100 sm:px-[15px]'>
                        <div className=''>
                            <img src={CheckOutIcon} className='mx-auto object-cover h-[96px] w-[96px] bg-[#ACCBFF] rounded-full' alt="" />
                        </div>
                        <div className='mt-3'>
                            <h1 className='britti_medium fs_24 text-center'>Are you sure?</h1>
                            <h2 className='txt_grey fs_16 mt-2 text-center'>Ending your check-in will remove your visibility from the map and general city chat. </h2>
                            <h3 className='mt-4 txt_grey fs_16 text-center'>You can always check in again later.</h3>
                        </div>

                        <div className='w-full mt-[18px]'>
                            <span className='text-start text-[#525866] fs_12'>Check-In Summary</span>
                            <div className='checkIn_Detail_card'>
                                <div className="relative">
                                    <img
                                        src={placeImageUrl}
                                        className='rounded-[12px] w-[48px] h-[48px] object-cover'
                                        alt={placeName || 'Place'}
                                        onError={handleImageError}
                                    />
                                    {imageLoading && (
                                        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-[12px]">
                                            <div className="w-4 h-4 border-2 border-[var(--primary)] border-t-transparent rounded-full animate-spin"></div>
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <h1 className='fs_16 britti_bold'>{checkInData?.checkInType} - {placeName || 'Your location'}</h1>
                                    <detail className='txt_grey fs_14'>{RemainingTime} left {(checkInData?.status_text) ? <>- {checkInData?.status_text}</> : ""}</detail>
                                </div>
                            </div>
                        </div>

                        {error ? (
                            <div className='w-full mt-3 text-center text-red-500 fs_14' role="alert">{error}</div>
                        ) : null}

                        <div className="btnGroup grid grid-cols-1 w-full gap-2 mt-4">
                            <button className='primary_btn w-full rounded-[12px]' onClick={() => handleCheckOut()} disabled={loading}>
                                {loading ? <><Spinner animation="border" variant="light" /></> : <>Yes, End Check-In</>}
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default CheckOut
